import styled from 'styled-components';
import { BackArrow } from 'lib/styles/icons';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import palette from 'lib/styles/palette';
import { createAdministrator } from 'lib/api/auth';
import { useMutation, useQueryClient } from 'react-query';
import useLoginCheck from 'hooks/common/useLoginCheck';

const AccountCreatePage = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const [error, setError] = useState('');
  const canGoNext = name && tel;

  const createAdministratorMutation = useMutation(createAdministrator, {
    onSuccess: () => {
      queryClient.invalidateQueries('accounts');
      navigate('/admin/accounts');
    },
    onError: error => {
      setError(error.response.data.msg);
    },
  });

  useLoginCheck(createAdministratorMutation.error?.response, () => {
    createAdministratorMutation.mutate({ userId: id, name, tel });
  });

  const onCreate = () => {
    createAdministratorMutation.mutate({ userId: id, name, tel });
  };

  return (
    <Container>
      <Header>
        <Icon onClick={() => navigate('/admin/accounts')}>
          <BackArrow />
        </Icon>
        <span>계정 추가</span>
      </Header>
      <InputWrapper>
        <Label>이메일: </Label>
        <Input value={id} onChange={e => setId(e.target.value)} />
      </InputWrapper>
      <InputWrapper>
        <Label>이름: </Label>
        <Input value={name} onChange={e => setName(e.target.value)} />
      </InputWrapper>
      <InputWrapper>
        <Label>전화번호: </Label>
        <Input value={tel} onChange={e => setTel(e.target.value)} />
      </InputWrapper>
      {error && <div className="error-message">{error}</div>}
      <Button disabled={!canGoNext} onClick={onCreate}>
        추가
      </Button>
    </Container>
  );
};

const Container = styled.div`
  width: 400px;
  height: 350px;
  margin: 0 auto;
  margin-top: 60px;
  background-color: #fff;
  border-radius: 10px;
  border: 2px solid black;
  padding: 20px;
  .error-message {
    color: red;
    text-align: center;
  }
`;

const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  display: flex;
  justify-content: center;
  position: relative;
  margin-bottom: 30px;
`;

const Icon = styled.div`
  position: absolute;
  top: 2px;
  left: 20px;
`;

const InputWrapper = styled.div`
  display: flex;
  margin-bottom: 30px;
`;

const Label = styled.div`
  width: 80px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 10px;
`;

const Input = styled.input`
  padding: 5px 10px;
  border-radius: 7px;
  border: 1px solid gray;
`;

const Button = styled.button`
  margin: 0 auto;
  background-color: ${palette.theme[3]};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: none;
  margin-top: 20px;
  font-size: 16px;
  padding: 10px 40px;
  letter-spacing: 4px;
  cursor: pointer;
  &:disabled {
    background-color: ${palette.theme[0]};
  }
`;

export default AccountCreatePage;
